import React, { useContext } from "react";
import "./Modulos.css";
import AppContext from "../../Store/AppContext";
import { ListaAcessos } from "../../Services/Acessos";
import { ObterContaWhatsAppDefault } from "../../Services/WhatsApp";
const images = require.context("../../assets/img/icones/modulos", true);

const Modulo = ({ idModulo, titulo, descricao, icone }) => {
  const { setAcessos, setModulo, setContaWhatsAppDefault, setShowSideBar, setAiHabilitada } = useContext(AppContext);
  const imagemIcone = images(`./${icone}`);
  const handleOnClick = async (modulo, titulo) => {
    const responseListaAcessos = await ListaAcessos(idModulo);
    setAcessos(await responseListaAcessos.funcoes);
    setModulo({ idModulo, titulo });
    setShowSideBar(true);
    setAiHabilitada(false);

    const responseObterContaWhatsAppDefault = await ObterContaWhatsAppDefault(idModulo);
    setContaWhatsAppDefault(await responseObterContaWhatsAppDefault.contaMeta);

    window.location.replace(`/Home`);
  };
  return (
    <div className="telaModulosV2Card"
      role="button"
      onClick={() => handleOnClick(idModulo, titulo)}>
      <img src={imagemIcone} alt={titulo} />
      {descricao}
    </div>
  );
};

export default Modulo;
